import React from 'react';
import { Theme, makeStyles, createStyles } from '@material-ui/core';
import clsx from 'clsx';
import { getPublicImageURL } from '../../utils/ImageUtils';
import { BaseMenu } from '../Dropdowns';
import { LockOpenIcon, PlusIcon } from '../Icons';
import { AuthenticatedPortalDataType } from '../Onboarding/Login/onboardingLoginTypes';
import Button from '../Button';
import history from '../../history';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuButton: {
      padding: theme.spacing(0.5, 1),
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
      width: '-webkit-fill-available',
      justifyContent: 'flex-start',
    },
    active: {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
);
export const SidebarLogoMenu: React.FC = ({ children }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const authenticatedPortals = JSON.parse(
    window.localStorage.getItem('authenticatedPortals') || '[]',
  );

  const workspacesActions = (authenticatedPortals as AuthenticatedPortalDataType[]).map(
    portal => ({
      name: portal.name,
      onClick: () => {
        history.replace(`/portal/${portal.id}`);
      },
      icon: (
        <img
          width={28}
          height={28}
          src={getPublicImageURL(portal.iconUrl)}
          alt="logo"
        />
      ),
    }),
  );

  const defaultActions = [
    {
      name: 'Sign in to another portal',
      icon: <LockOpenIcon style={{ fontSize: 16 }} />,
      onClick: () => {
        history.replace('/onboarding/login');
      },
      iconStyle: {
        height: 28,
        width: 28,
      },
    },
    {
      name: 'Create a new portal',
      icon: <PlusIcon style={{ fontSize: 16 }} />,
      onClick: () => {
        history.replace('/onboarding');
      },
      iconStyle: {
        height: 28,
        width: 28,
      },
    },
  ];

  return (
    <>
      <Button
        className={clsx(classes.menuButton, { [classes.active]: !!anchorEl })}
        data-testid="sidebar-logo-menu"
        htmlId="sidebar-logo-menu"
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        {children}
      </Button>
      <BaseMenu
        actions={[...workspacesActions, ...defaultActions]}
        menuProps={{
          id: 'actions-menu',
          'data-testid': 'workspaces-menu',
          anchorEl,
          getContentAnchorEl: null,
          keepMounted: true,
          open: Boolean(anchorEl),
          onClose: () => setAnchorEl(null),
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        }}
      />
    </>
  );
};
